import { ErrorHandler } from '@angular/core';

declare const RC:any;
const logger = new RC.Logger({
  applicationId           : 'afc94d273a39ecb7501ef8d39f031099',
  recordUserActions       : true,
  recordSessionVideo      : true,
  logResourceLoadFailures : true,
  logAjaxRequests         : true,
  captureScreenshot       : true,
  onErrorLogged: (<any>window).onErrorLogged,
  newErrorText: 'An error was caught and successfully logged, id <a href="{link}?demo">#{id}</a>',
  showNotificationOnError: true,
  frameworkVersion        : 'Angular 2',
  user                    : {
      name   : 'Dan Anderson',
      email  : 'demouser@therootcause.io',
      imgUrl : 'https://s.gravatar.com/avatar/0b9e04aed9dcc2d3a121522147dfc7fa?s=80'
  }
});

export default class MyErrorHandler implements ErrorHandler {
   handleError(error) {
     logger.logException(error);
     console.error(error);
   }
}



// WEBPACK FOOTER //
// /home/node/angular-material-demo/src/app/errorHandler.ts